// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null,
}

const inalarm = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_IN_ALARM':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_DATA_IN_ALARM_MEMBER':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_IN_ALARM':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_IN_ALARM':
      return { ...state }
    case 'EDIT_IN_ALARM':
      return { ...state }
    case 'DELETE_IN_ALARM':
      return { ...state }
    default:
      return { ...state }
  }
}
export default inalarm
